module.exports = __webpack_public_path__ + "img/view-from-air.c297b198.jpg";